"use client";
import MonarchResolver from "@/monarch/MonarchResolver";
import type { MultiCartTestResult } from "@/monarch/rules/multiCart/types";
import MultiCartComponent from "./MultiCartTest";

interface MultiCartProps {
  defaultContent: string;
  defaultUrl?: string;
  defaultIcon?: string;
  className?: string;
  cartData?: {
    items: Array<{
      id: number;
      courseName: string;
      price: number;
      originalPrice?: number;
      quantity: number;
      discount?: number;
    }>;
    subtotal: number;
    discounts: Array<{
      type: "percentage" | "fixed";
      value: number;
      description: string;
    }>;
    total: number;
    tax: number;
    shipping: number;
  };
}

export default function MultiCart({
  defaultContent,
  defaultUrl,
  defaultIcon,
  className,
  cartData,
}: MultiCartProps) {
  return (
    <MonarchResolver<MultiCartTestResult>
      experimentKey="useMultiCart"
      variants={{
        control: null,
        test: <MultiCartComponent className={className} />,
      }}
      Loader={null}
    />
  );
}
